/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import { Gantt, ViewMode } from "gantt-task-react";
import "gantt-task-react/dist/index.css";
import "./gantt.css";

function formatDateInput(date) {
  if (!date) return "";
  const d = new Date(date);
  const offset = d.getTimezoneOffset();
  const local = new Date(d.getTime() - offset * 60 * 1000);
  return local.toISOString().slice(0, 10);
}

function formatDateForSave(date) {
  if (!date) return "";
  const d = new Date(date);
  const offset = d.getTimezoneOffset();
  const local = new Date(d.getTime() - offset * 60 * 1000);
  return local.toISOString().slice(0, 10);
}

const TaskEditModal = ({
  task,
  allTasks,
  onClose,
  onSave,
  onDelete,
  onChange,
}) => {
  if (!task) return null;
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.3)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: 24,
          borderRadius: 8,
          minWidth: 340,
          boxShadow: "0 2px 8px #0002",
        }}
      >
        <h3 className="text-lg font-bold mb-2">Edit Task</h3>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSave();
          }}
        >
          <div className="mb-2">
            <label className="block mb-1">Name</label>
            <input
              className="border rounded px-2 py-1 w-full"
              value={task.name}
              onChange={(e) => onChange({ ...task, name: e.target.value })}
            />
          </div>
          <div className="mb-2">
            <label className="block mb-1">Progress (0-100)</label>
            <input
              type="number"
              min={0}
              max={100}
              className="border rounded px-2 py-1 w-full"
              value={task.progress}
              onChange={(e) =>
                onChange({ ...task, progress: Number(e.target.value) })
              }
            />
          </div>
          <div className="mb-2">
            <label className="block mb-1">Start Date</label>
            <input
              type="date"
              className="border rounded px-2 py-1 w-full"
              value={formatDateInput(task.start)}
              onChange={(e) =>
                onChange({
                  ...task,
                  start: e.target.value
                    ? new Date(e.target.value + "T00:00:00")
                    : null,
                })
              }
            />
          </div>
          <div className="mb-2">
            <label className="block mb-1">End Date</label>
            <input
              type="date"
              className="border rounded px-2 py-1 w-full"
              value={formatDateInput(task.end)}
              onChange={(e) =>
                onChange({
                  ...task,
                  end: e.target.value
                    ? new Date(e.target.value + "T00:00:00")
                    : null,
                })
              }
            />
          </div>
          <div className="mb-2">
            <label className="block mb-1">Owner (optional)</label>
            <input
              className="border rounded px-2 py-1 w-full"
              value={task.owner || ""}
              onChange={(e) => onChange({ ...task, owner: e.target.value })}
            />
          </div>
          <div className="mb-2">
            <label className="block mb-1">Type</label>
            <select
              className="border rounded px-2 py-1 w-full"
              value={task.type}
              onChange={(e) => onChange({ ...task, type: e.target.value })}
            >
              <option value="task">Task</option>
              <option value="milestone">Milestone</option>
              <option value="project">Project</option>
            </select>
          </div>
          <div className="mb-2">
            <label className="block mb-1">Dependencies</label>
            <select
              multiple
              className="border rounded px-2 py-1 w-full"
              value={task.dependencies || []}
              onChange={(e) =>
                onChange({
                  ...task,
                  dependencies: Array.from(
                    e.target.selectedOptions,
                    (o) => o.value,
                  ),
                })
              }
            >
              {allTasks
                .filter((t) => t.id !== task.id)
                .map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.name}
                  </option>
                ))}
            </select>
          </div>
          <div className="flex gap-2 mt-4">
            <button
              type="submit"
              className="bg-green-600 text-white px-3 py-1 rounded"
            >
              Save
            </button>
            <button
              type="button"
              className="bg-red-500 text-white px-3 py-1 rounded"
              onClick={onDelete}
            >
              Delete
            </button>
            <button
              type="button"
              className="bg-gray-300 px-3 py-1 rounded"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const MarSchedule = () => {
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [ganttLoading, setGanttLoading] = useState(true);
  const [error, setError] = useState(null);
  const [viewMode, setViewMode] = useState(ViewMode.Week);
  const [editTask, setEditTask] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editTaskDraft, setEditTaskDraft] = useState(null);

  const project = JSON.parse(localStorage.getItem("selectedProject") || "null");
  const projectId = project ? project.id : null;

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const fetchTasks = useCallback(async (projId) => {
    setError(null);
    setGanttLoading(true);
    try {
      const response = await fetch(`/api/marketing_tasks?projectId=${projId}`);
      if (!response.ok) throw new Error("Failed to fetch tasks");
      const data = await response.json();
      const formattedTasks = data
        .map((task) => ({
          id: task._id,
          name: task.task_name,
          start: new Date(task.start_date),
          end: new Date(task.end_date),
          type: task.type || "task",
          progress: task.progress || 0,
          dependencies: task.dependencies || [],
          owner: task.owner || "",
          styles: {
            progressColor: "#88B169",
            progressSelectedColor: "#6FA944",
            barHeight: 20,
          },
        }))
        .sort((a, b) => a.start - b.start);
      setTasks(formattedTasks);
    } catch (error) {
      setError(error.message || "Failed to load tasks");
    } finally {
      setGanttLoading(false);
    }
  }, []);

  useEffect(() => {
    const role = localStorage.getItem("userRole");
    if (!role) {
      navigate("/");
    } else {
      setUserRole(role);
    }
    if (projectId) {
      fetchTasks(projectId);
    }
  }, [navigate, projectId, fetchTasks]);

  const handleAddTask = async (e) => {
    e.preventDefault();
    setError(null);
    const formData = new FormData(e.target);
    const newTask = {
      projectId: projectId,
      task_name: formData.get("task_name"),
      start_date: formData.get("start_date"),
      end_date: formData.get("end_date"),
      owner: formData.get("owner"),
      progress: 0,
    };
    try {
      const response = await fetch("/api/marketing_tasks", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newTask),
      });
      if (!response.ok) throw new Error("Failed to add task");
      if (projectId) {
        fetchTasks(projectId);
      }
      e.target.reset();
    } catch (error) {
      setError(error.message || "Failed to add task");
    }
  };

  const handleTaskClick = (task) => {
    setEditTask(task);
    setEditTaskDraft({ ...task });
    setShowModal(true);
  };

  const handleSaveTask = async () => {
    if (!editTaskDraft) return;
    await fetch(`/api/marketing_tasks/${editTaskDraft.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        task_name: editTaskDraft.name,
        start_date: formatDateForSave(editTaskDraft.start),
        end_date: formatDateForSave(editTaskDraft.end),
        progress: editTaskDraft.progress,
        dependencies: editTaskDraft.dependencies,
        type: editTaskDraft.type,
        owner: editTaskDraft.owner || undefined,
      }),
    });
    setShowModal(false);
    setEditTask(null);
    setEditTaskDraft(null);
    fetchTasks(projectId);
  };

  const handleDeleteTask = async () => {
    if (!editTaskDraft) return;
    await fetch(`/api/marketing_tasks/${editTaskDraft.id}`, {
      method: "DELETE",
    });
    setShowModal(false);
    setEditTask(null);
    setEditTaskDraft(null);
    fetchTasks(projectId);
  };

  const handleCancel = () => {
    setShowModal(false);
    setEditTask(null);
    setEditTaskDraft(null);
  };

  return (
    <div className="flex h-screen">
      <Sidebar userRole={userRole} projectId={projectId} scenario="marketing" />
      <div className="flex-1 p-6 bg-gray-50 text-[12px] ml-[60px]">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-[18px]">Marketing Schedule</h2>
          <img src="/images/gemterra-logo-20260112-t.png" alt="Gemterra" className="h-6" />
        </div>
        <form
          onSubmit={handleAddTask}
          className="mb-6 w-auto text-[12px] text-left"
        >
          <div className="flex flex-row gap-4 items-end">
            <div>
              <label className="block mb-1 font-medium text-[12px]">
                Task Name
              </label>
              <input
                type="text"
                name="task_name"
                required
                className="w-44 border rounded px-3 py-1 text-[12px]"
              />
            </div>
            <div>
              <label className="block mb-1 font-medium text-[12px]">
                Start Date
              </label>
              <input
                type="date"
                name="start_date"
                required
                className="w-44 border rounded px-3 py-1 text-[12px]"
              />
            </div>
            <div>
              <label className="block mb-1 font-medium text-[12px]">
                End Date
              </label>
              <input
                type="date"
                name="end_date"
                required
                className="w-44 border rounded px-3 py-1 text-[12px]"
              />
            </div>
            <div className="flex items-end h-full">
              <button
                type="submit"
                className="text-white px-3 py-1 rounded text-[12px] h-[32px]"
                style={{ backgroundColor: "#6FA944" }}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor = "#5C8E37")
                }
                onMouseOut={(e) => (e.target.style.backgroundColor = "#6FA944")}
              >
                Add Task
              </button>
            </div>
            <div className="flex items-end h-full gap-2 ml-2">
              {[
                { mode: ViewMode.Month, label: "M" },
                { mode: ViewMode.Week, label: "W" },
                { mode: ViewMode.Day, label: "D" },
              ].map(({ mode, label }) => (
                <button
                  key={label}
                  type="button"
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-[12px] font-bold border ${
                    viewMode === mode
                      ? "bg-green-600 text-white border-green-600"
                      : "bg-gray-200 text-gray-800 border-gray-300"
                  }`}
                  style={
                    viewMode === mode ? { backgroundColor: "#6FA944" } : {}
                  }
                  onClick={() => setViewMode(mode)}
                  onMouseOver={(e) => {
                    if (viewMode !== mode)
                      e.target.style.backgroundColor = "#e5e7eb";
                  }}
                  onMouseOut={(e) => {
                    if (viewMode !== mode) e.target.style.backgroundColor = "";
                  }}
                  title={
                    label === "M" ? "Month" : label === "W" ? "Week" : "Day"
                  }
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
          {error && <div className="text-red-600 mt-2">{error}</div>}
        </form>
        <div style={{ height: "500px" }}>
          {ganttLoading ? (
            <div className="flex items-center justify-center h-full">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500"></div>
              <span className="ml-3 text-[12px]">Loading Gantt chart...</span>
            </div>
          ) : tasks.length > 0 ? (
            <div className="gantt-container">
              <Gantt
                tasks={tasks}
                viewMode={viewMode}
                listCellWidth={"155px"}
                columnWidth={60}
                height={450}
                rowHeight={30}
                onClick={handleTaskClick}
              />
              <TaskEditModal
                task={editTaskDraft}
                allTasks={tasks}
                onClose={handleCancel}
                onSave={handleSaveTask}
                onDelete={handleDeleteTask}
                onChange={setEditTaskDraft}
              />
            </div>
          ) : (
            <div className="text-gray-500 text-center mt-8 text-[12px]">
              <p>No tasks available.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MarSchedule;
